import { buildStreamedDataStreamSlice } from 'streamsState/store/streamedData/streamSlice';
import State from 'store/State';
import { selectStreamedDataState } from 'streamsState/store/streamedData/selectors';

import {
    HistPriceVolStreamState,
    initialHistPriceVolDataState,
} from 'widgets/historicalPercentageChange/store/data/HistoricalPercentageChangeDataState';
import { HistPriceVolElement } from 'widgets/historicalPercentageChange/api/HistPriceVolElement';
import { HistPriceVolStreamElementType } from 'widgets/historicalPercentageChange/api/HistPriceVolStreamElementType';
import isNil from 'lodash/isNil';
import {
    createHistoricalPercentageChangeRequestUid,
    toHistPriceVolRequestUid,
} from './HistoricalPercentageChangeStreamRequest.ts';
import cloneDeep from 'lodash/cloneDeep';

const processStreamElement = (
    element: HistPriceVolElement,
    nextState: HistPriceVolStreamState
) => {
    if (
        element._c !== HistPriceVolStreamElementType.HistoricalData &&
        element._c !== HistPriceVolStreamElementType.TodayData
    ) {
        // We only care about the data...
        return;
    }

    nextState.data = cloneDeep(nextState.data || initialHistPriceVolDataState);
    const nextItems = nextState.data?.data ?? [];

    for (const item of element.data) {
        // TODO: remove when back end reliably sends index...
        const index = item.index == undefined ? 0 : item.index;

        let nextItem = nextItems.find((d) => d.index === index);
        if (!nextItem) {
            nextItem = {
                date: item.date,
                index: index,
                volume: item.v,
                price: item.p,
            };
            nextItems.push(nextItem);
        } else {
            if (!isNil(item.v)) {
                nextItem.volume = item.v;
            }
            if (!isNil(item.p)) {
                nextItem.price = item.p;
            }
        }
    }
};

export function buildHistPriceVolStreamSlice() {
    const selectHistoricalPercentageChangeStreamedData = (state: State) =>
        selectStreamedDataState(state).histPriceVol;

    return buildStreamedDataStreamSlice(
        'startHistPriceVolStream',
        { messages: [] },
        selectHistoricalPercentageChangeStreamedData,
        createHistoricalPercentageChangeRequestUid,
        toHistPriceVolRequestUid,
        processStreamElement
    );
}

const {
    reducer: histPriceVolStreamStreamedDataReducer,
    selectors: histPriceVolStreamedDataSelectorsTemp,
} = buildHistPriceVolStreamSlice();

const histPriceVolStreamedDataSelectors: typeof histPriceVolStreamedDataSelectorsTemp =
    {
        ...histPriceVolStreamedDataSelectorsTemp,
        // useSymbolStreamedData: () => historicalPercentageChangeTestData,
        // useWidgetStreamData: () => historicalPercentageChangeTestData,
    };

export {
    histPriceVolStreamStreamedDataReducer,
    histPriceVolStreamedDataSelectors,
};
